module.exports = __webpack_public_path__ + "img/effects_sketcher.df01e510.jpg";